import 'src/components/feedback/Spin/Spin.css.ts.vanilla.css?source=LlNwaW5fc3BpbkJsdXJfX3BmMnI0ZjAgewogIGZpbHRlcjogYmx1cigzcHgpOwogIHRyYW5zaXRpb246IGZpbHRlciAwLjNzOwp9';
export var spinBlur = 'Spin_spinBlur__pf2r4f0';